import { useContext, useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css";
import Load from '../Load/Load'
import ReactQuill from "react-quill";
import { getPrivacyPolicy, updatePrivacyPolicy, createPrivacyPolicy } from "../../Web Apis/webApis"
import { message } from "antd";
import { useNavigate } from "react-router";
// import { UserContext } from "../../App";

const Privacy = () => {
  const navigate = useNavigate();
  // const { setIsAuthenticated } = useContext(UserContext);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [text, setText] = useState("");
  const [disableStatus, setDisableStatus] = useState(true);
  const [isPolicyCreated, setIsPolicyCreated] = useState(false); // Track if policy exists

  // Fetch Privacy Policy
  const getPrivacyPolicyApi = async () => {
    setLoading(true);
    try {
      const response = await getPrivacyPolicy();
      if (response?.data?.success) {
        const policyData = response?.data?.data[0];
        setData(policyData);
        setText(policyData?.content);
        setIsPolicyCreated(!!policyData); // Set policy existence status
      }
    } catch (error) {
      console.error("Error fetching privacy policy:", error);
      if (error.message === 'Network Error' || error.message.includes('ERR_INTERNET_DISCONNECTED')) {
        // Handle internet disconnection
        return;
      }
      // Handle specific error cases
      if (error?.response?.status === 401) {
        window.alert("Your account is logged in to another device, please login again !")
        localStorage.removeItem('token');
        // setIsAuthenticated(false)
        window.location.href = "/login";
      }
      if (error?.response?.status === 500) {
        message.error("Server not responding")
        return;
      } else {
        return ;
      }
     
    } finally {
      setLoading(false);
    }
  };

  // Create Privacy Policy
  const createPrivacyPolicyApi = async () => {
    const plainText = sentHtml(text).trim();

    if(!plainText){
      message.error("Content can not be empty")
      return ;
    }
    setLoading(true);
    try {
      const response = await createPrivacyPolicy({ content: text });
      if (response?.data?.success) {
        message.success(response?.data?.message);
        await getPrivacyPolicyApi(); // Refresh data after creation
      }
    } catch (error) {
      console.log("Error while creating privacy policy:", error);
      message.error(error?.response?.data?.message || "Error in creating privacy policy");
    } finally {
      setLoading(false);
    }
  };

const sentHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}


  // Update Privacy Policy
  const updatePrivacyPolicyApi = async () => {
  
    const plainText = sentHtml(text).trim();

    if(!plainText){
      message.error("Content can not be empty")
      return ;
    }

    setLoading(true);
    try {
      const response = await updatePrivacyPolicy(data.id, { content: text });
      if (response?.data?.success) {
        message.success(response?.data?.message);
        setDisableStatus(true);
      } else {
        message.error("Failed to update privacy policy");
      }
    } catch (error) {
      console.error("Error updating privacy policy:", error);
      message.error("Error while updating privacy policy");
    } finally {
      setLoading(false);
    }
  };

  // Load Privacy Policy on component mount
  useEffect(() => {
    getPrivacyPolicyApi();
  }, []);

  // Handle content change in ReactQuill editor
  const handleChange = (value) => {
    setText(value);
    setDisableStatus(false);
  };

  return (


<div className="mt-28">
      <div style={{ width: "90%", margin: "0 auto" }}>
    
        <div style={{ marginTop: "100px" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
            <h1 style={{ fontSize: "22px", fontWeight: 600 }}>Privacy Policy</h1>
           
          </div>
          <ReactQuill
            value={text}
            onChange={handleChange}
            placeholder="Write your privacy policies here..."
            theme="snow"
            className="mb-4"
            style={{ height: "300px" }}
          />
        </div>
      </div>
      <div className="flex flex-row justify-end items-center w-full">
        <button
          onClick={isPolicyCreated ? updatePrivacyPolicyApi : createPrivacyPolicyApi}
          disabled={disableStatus}
          style={{
            backgroundColor: disableStatus ? "grey" : "teal",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "10px",
            marginTop: "60px",
            marginRight: "80px",
          }}
        >
          {isPolicyCreated ? "Update Privacy Policy" : "Create Privacy Policy"}
        </button>
      </div>

      {loading && <Load />}
</div>
  );
};

export default Privacy;

